import React, { useEffect, useState } from 'react'
import ClientCompanyTypeModel from './models/ClientEnvironmentModel';

function DeleteClientEnvironment(props) {
  const [getDeleteClientCompanyType, setDeleteClientCompanyType] = useState(new ClientCompanyTypeModel() || []);

  useEffect(() => {
    setDeleteClientCompanyType(props.ClientCompanyTypeData);
  }, [props.ClientCompanyTypeData])
  return (
    <>
      <div className="text-left px-2 pb-0">
        <p>
          <h6>Following Client company type will be deleted and could not be recovered!!</h6>
          <ul>
            <li><b>Client Company Type :</b> {getDeleteClientCompanyType.ClientCompanyTypeName}</li>
            <li><b>Description : </b>{getDeleteClientCompanyType.Description}</li>
          </ul>
        </p>
      </div>
      <div id="DeleteClientCompanyTypeDetails" hidden>{JSON.stringify(getDeleteClientCompanyType)}</div>
    </>
  )
}

export default DeleteClientEnvironment